var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50009 9.65387C10.0932 9.65387 11.3847 8.36239 11.3847 6.76926C11.3847 5.17613 10.0932 3.88464 8.50009 3.88464C6.90697 3.88464 5.61548 5.17613 5.61548 6.76926C5.61548 8.36239 6.90697 9.65387 8.50009 9.65387Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.573 14.1539C4.08789 13.3087 4.81155 12.6101 5.67439 12.1255C6.53724 11.6408 7.51026 11.3862 8.49992 11.3862C9.48959 11.3862 10.4626 11.6408 11.3254 12.1255C12.1883 12.6101 12.9119 13.3087 13.4269 14.1539",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C12.6422 16 16 12.6422 16 8.5C16 4.35787 12.6422 1 8.5 1C4.35787 1 1 4.35787 1 8.5C1 12.6422 4.35787 16 8.5 16Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.9cfb660a91c2a8e4999c1b5ef6ba89b0.svg";
export { ForwardRef as ReactComponent };